<script setup>
import { computed } from 'vue'

const { price } = defineProps({
  price: {
    type: Object,
    required: false
  },
  prefix: {
    type: String,
    default: ''
  },
  postfix: {
    type: String,
    default: ''
  },
  fontSize: {
    type: Number,
    default: 1
  },
  fontWeight: {
    type: Number,
    default: 400
  }
})

const currency = computed(() => {
  const currencies = { EUR: '€' }
  if (Object.keys(currencies).includes(price.currencyCode)) {
    return currencies[price.currencyCode]
  }
  return price.currencyCode
})
</script>

<template>
  <div
    v-if="price"
    class="price"
    :style="`--font-size: ${fontSize}rem; --font-weight: ${fontWeight};`"
  >
    <span v-if="prefix" class="price__prefix">{{ prefix }}</span>
    <span class="price__value">{{
      Intl.NumberFormat('de-DE', { minimumFractionDigits: 2 }).format(price.amount)
    }}</span>
    <span class="price__currency">{{ currency }}</span>
    <span v-if="postfix" class="price__vat">{{ postfix }}</span>
  </div>
</template>

<style lang="scss" scoped>
.price {
  display: flex;
  align-items: baseline;
  font-size: var(--font-size, 1rem);

  &__prefix {
    font-size: 0.7em;
    margin-right: 0.5rem;
  }

  &__value,
  &__currency {
    font-weight: 600;/*var(--font-weight, 400);*/
    font-family: "Open Sans";
    font-size: 11px;/* var(--font-size, 1rem);*/
    font-style: normal;
    line-height: 24px;
  }

  &__currency {
    padding-left: 4px;
  }

  &__vat {
    color: var(--clr-gray-500);
    font-family: "Open Sans";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    padding-left: 9px;
  }
}
.cart__footer .price__value {
  font-size: 14px;
  font-weight: 700;
}
</style>
